import { useContext, useMemo } from 'react'
import { AuthContext } from '@/contexts/AuthContext/AuthContext'

export function useAuth() {
    const context = useContext(AuthContext)
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider')
    }

    const currentMastodonHandle = useMemo(() => {
        if (!context.mastodonSession) return undefined
        const host = new URL(context.mastodonSession.instance_url).host
        return `${context.mastodonSession.account.username}@${host}`.toLowerCase()
    }, [context.mastodonSession])

    const currentPixelfedHandle = useMemo(() => {
        if (!context.pixelfedSession) return undefined
        const host = new URL(context.pixelfedSession.instance_url).host
        return `${context.pixelfedSession.account.username}@${host}`.toLowerCase()
    }, [context.pixelfedSession])

    return { ...context, currentMastodonHandle, currentPixelfedHandle }
}
